import { sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { RosterDay } from '../../types';
import { OpenRequestsRow as OpenRequestsRowType } from './types';
import { PlanUnit } from 'components/types';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';

import { Accordion } from 'components/shared';

import OpenRequestsRow from './OpenRequestsRow';

const OpenRequestsGridStyles = styled.div`
  flex-grow: 1;
  position: relative;

  .wrap-container > div {
    height: 100%;
    overflow-y: scroll;
  }
`;

type Props = {
  openRequestsRows: OpenRequestsRowType[];
  isAccordion?: boolean;
  selectedPlanUnits: PlanUnit[];
  rosterDays: RosterDay[];
  portal: string;
};

export default function OpenRequestsGrid({
  openRequestsRows,
  isAccordion,
  selectedPlanUnits,
  rosterDays,
  portal
}: Props) {
  const { t } = useTranslation('common');
  const children = (
    <Table className="roster-grid">
      <TableBody>
        {sortBy(openRequestsRows, 'openRequest.function.name').map(
          (openRequestsRow) => (
            <OpenRequestsRow
              key={openRequestsRow.id}
              openRequestsRow={openRequestsRow}
              selectedPlanUnits={selectedPlanUnits}
              rosterDays={rosterDays}
              portal={portal}
            />
          )
        )}
      </TableBody>
    </Table>
  );
  if (isAccordion) {
    return (
      <Accordion disableGutters summary={t('openRequests')} defaultExpanded>
        {children}
      </Accordion>
    );
  }
  return (
    <OpenRequestsGridStyles className="open-requests-container">
      <div className="wrap-container">
        <div>{children}</div>
      </div>
    </OpenRequestsGridStyles>
  );
}
